import { trackEvent } from '~/adapters/tracking/tracking';

export const sendFeedbackPageEvent = (action: string, label?: string): void => {
    trackEvent({ category: 'Account Feedback', action, label });
};
